import { combineReducers } from 'redux'
import misc from './misc'
import publicholiday from './publicholiday'

export default combineReducers({
  misc,
  publicholiday,
})
